/* v2-trust.js - moved out of the page into a cached asset (was inline).
   Runs once per page; in the theme editor it re-runs when a section reloads,
   exactly as the inline version did. */
(function () {
if (window.__v2Asset_v2_trust_js) return;
window.__v2Asset_v2_trust_js = 1;
function v2run() {
(function () {
  'use strict';

  var cfg = document.querySelector('[data-v2-trust-cfg]');
  if (!cfg) return;
  /* 'bleed' is the treatment that puts the bar on the picture's edges and
     flush against it. 'original' leaves the bar as a bordered card in the
     gallery column and does none of the measuring below. */
  var BLEED = cfg.getAttribute('data-mobile') === 'bleed';

  var ICONS = {
    seal:   '<circle cx="12" cy="10" r="6"/><path d="M8.9 10.2l2 2 3.5-3.7M8.6 15.4L7.5 21l4.5-2.2L16.5 21l-1.1-5.6"/>',
    ruler:  '<rect x="2.5" y="8.5" width="19" height="7" rx="1.2"/><path d="M7 8.5v2.6M11 8.5v3.6M15 8.5v2.6M19 8.5v3.6"/>',
    shield: '<path d="M12 3l7 3v5c0 4.2-2.8 8-7 10-4.2-2-7-5.8-7-10V6l7-3z"/>',
    cert:   '<path d="M6 3h9l4 4v10.5a1.5 1.5 0 0 1-1.5 1.5H6a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 6 3z"/><path d="M14.5 3v4.5H19M8 12h6M8 15.5h4"/>',
    leaf:   '<path d="M20 4c0 9-5.5 13-9.5 13A4.5 4.5 0 0 1 6 12.5C6 7 12 4 20 4zM6 20c1.5-4 4-6.5 7-8"/>',
    truck:  '<path d="M2.5 7h10v9h-10zM12.5 10.5H17l3 3V16h-7.5z"/><circle cx="6" cy="17.5" r="1.6"/><circle cx="16" cy="17.5" r="1.6"/>'
  };

  function cell(text, icon) {
    var d = document.createElement('div');
    var svg = '<svg viewBox="0 0 24 24" aria-hidden="true">' +
              (ICONS[icon] || ICONS.shield) + '</svg>';
    d.innerHTML = svg;
    d.appendChild(document.createTextNode(text));
    return d;
  }

  function build() {
    /* Same page-level gate as the gallery dots: the v2 buy box has to be
       here before anything is added to the page. */
    if (!document.querySelector('.v2-pdp, [data-v2-groups]')) return false;
    if (document.querySelector('[data-v2-trust]')) return true;

    var gallery = document.querySelector('media-gallery:not([id*="-duplicate"])');
    if (!gallery) return false;

    /* The bar goes INSIDE media-gallery, after the photos - not after the
       gallery as a sibling. With sticky product information the gallery is
       position:sticky with z-index:2, and a sibling below it gets painted
       over: sticky lets the gallery slide down inside its container by
       exactly the height of whatever follows it, so the bar ends up beneath
       a 3500px transparent box that wins on z-index. Inside, it is simply
       the last thing in the column. */
    var host = gallery;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');

    var bar = document.createElement('div');
    bar.className = 'v2-trust';
    bar.setAttribute('data-v2-trust', '');
    bar.setAttribute('role', 'list');
    ['1', '2', '3'].forEach(function (n) {
      var t = cfg.getAttribute('data-' + n);
      if (!t) return;
      var c = cell(t, cfg.getAttribute('data-' + n + 'i'));
      c.setAttribute('role', 'listitem');
      bar.appendChild(c);
    });
    if (!bar.children.length) return true;

    if (viewer && viewer.nextSibling) host.insertBefore(bar, viewer.nextSibling);
    else host.appendChild(bar);

    /* Seat it. The CSS above flattens the margins we know about; this closes
       whatever is left, whichever element it came from.

       Measured against whatever sits DIRECTLY above the bar, not against the
       last photo. On a phone the gallery's scroll line lives between the two,
       and measuring to the photo pulled the bar up over it. */
    /* The photo the shopper is actually looking at - not the gallery column,
       which on a phone runs wider than the picture inside it. */
    /* the scroll container - as wide as the strip is allowed to be, peek and
       all, which on a phone reaches the edge of the screen */
    function frameRect() {
      var slider = gallery.querySelector('[id^="Slider-Gallery"], .product__media-list');
      if (!slider) return null;
      var r = slider.getBoundingClientRect();
      return r.width > 40 ? r : null;
    }

    /* Where the pictures START - and it must be the same number however far
       the strip has been swiped.

       The left inset is not one mechanism. It can be padding on the slider, a
       margin on the first slide, or a negative margin on the list with the
       gutter added back inside; her phone layout uses the last of those, so
       the SCROLL FRAME reaches the edge of the screen while the picture inside
       it starts on the page's gutter. Matching the frame there put the bar
       under the title instead of level with it.

       So it is measured, not declared: the first picture's own left edge taken
       back to scroll position 0. That is the edge the product title sits on,
       it comes out the same whichever mechanism the theme used, and it does
       not shift when the shopper swipes - which reading the snapped photo
       would, because after a swipe that photo sits on the frame's edge and not
       on the gutter. */
    function restLeft() {
      var slider = gallery.querySelector('[id^="Slider-Gallery"], .product__media-list');
      var items = gallery.querySelectorAll('.product__media-item');
      var first = null, i;
      for (i = 0; i < items.length; i++) {
        if (!items[i].getClientRects().length) continue;
        if (items[i].getBoundingClientRect().width < 40) continue;
        first = items[i];
        break;
      }
      if (!first) return null;
      var pic = first.querySelector('img, video, iframe, model-viewer');
      var pr = pic ? pic.getBoundingClientRect() : null;
      var box = (pr && pr.width > 40) ? pr : first.getBoundingClientRect();
      return box.left + (slider ? (slider.scrollLeft || 0) : 0);
    }

    function shotRect() {
      /* The PHOTO, not the scroll frame.

         On a phone the strip shows the next picture peeking past the right
         edge - that peek is inside the frame but it is not the photo, so
         matching the frame ran the bar out under it. The item currently
         snapped to the left of the frame is the one being looked at; taking
         the nearest one to the frame's left edge finds it whatever the strip
         has been scrolled to, which an individual item's own box cannot do. */
      var slider = gallery.querySelector('[id^="Slider-Gallery"], .product__media-list');
      var frame = slider ? slider.getBoundingClientRect() : null;
      var items = gallery.querySelectorAll('.product__media-item');
      var best = null, bestDist = Infinity;
      for (var i = 0; i < items.length; i++) {
        if (!items[i].getClientRects().length) continue;
        var r = items[i].getBoundingClientRect();
        if (r.width < 40) continue;
        var d = frame ? Math.abs(r.left - frame.left) : r.left;
        if (d < bestDist) { bestDist = d; best = r; }
      }
      if (best) {
        /* The IMAGE, not the item that holds it. With an inline image the
           item's box runs a few pixels lower than the picture - that is where
           the white band lives - so measuring the item would seat the bar
           against empty space and call it flush. */
        var host = null;
        for (i = 0; i < items.length; i++) {
          var ir = items[i].getBoundingClientRect();
          if (Math.abs(ir.left - best.left) < 0.5 && Math.abs(ir.width - best.width) < 0.5) {
            host = items[i]; break;
          }
        }
        var pic = host ? host.querySelector('img, video, iframe, model-viewer') : null;
        if (pic) {
          var pr = pic.getBoundingClientRect();
          if (pr.width > 40 && pr.height > 40) return pr;
        }
        return best;
      }
      if (frame && frame.width > 40) return frame;
      var img = gallery.querySelector('.product__media img, img.product__media-image, img');
      return img ? img.getBoundingClientRect() : null;
    }

    function seat() {
      bar.style.marginTop = '0px';
      var above = bar.previousElementSibling;
      if (!above) {
        var items = gallery.querySelectorAll('.product__media-item'), i;
        for (i = 0; i < items.length; i++) {
          if (items[i].offsetParent !== null || items[i].getClientRects().length) above = items[i];
        }
      }
      /* Measured to the PHOTO's bottom, not the element above.

         The gallery viewer runs a few pixels taller than the last picture -
         an image is inline by default and carries the baseline's descender
         space under it - so seating against the viewer left the bar three
         pixels below the photo. That thin white band is the gap, and no
         amount of margin on the bar could close it while the target was the
         wrong edge. */
      var photo = BLEED ? shotRect() : null;
      var topRef = photo ? photo.bottom
                 : (above ? above.getBoundingClientRect().bottom : null);
      if (topRef !== null) {
        var gap = bar.getBoundingClientRect().top - topRef;
        /* In 'original' the bar only ever closes a gap; in 'bleed' it also
           pulls up over the picture's own trailing space. */
        if (BLEED ? Math.abs(gap) > 0.5 : gap > 0.5) bar.style.marginTop = (-gap) + 'px';
      }

      /* Line the bar up with the picture's own edges. Measured rather than
         declared, because the inset comes from the theme's slider padding and
         is not a number this file can know - it differs between the phone
         layout and the wide one, and again when the gallery has a thumbnail
         rail. Both sides are read BEFORE either is applied, so shrinking the
         box on the left cannot skew the reading on the right. */
      /* The bar is as wide as the pictures, in BOTH modes.

         On a phone the theme's photo strip carries negative margins so it runs
         wider than the gallery box it sits in. The bar has no such margins, so
         left alone it stops short of the strip on the right and leaves a white
         notch beside the peeking photo. Matching the strip is not part of the
         'bleed' treatment - it is just the bar being the width of the thing it
         sits under. */
      bar.style.marginLeft = '0px';
      bar.style.marginRight = '0px';
      var frame = frameRect();
      var shot = shotRect();
      if (!frame && !shot) return;
      var b = bar.getBoundingClientRect();

      /* Left to the picture, right to the strip - and they are not the same
         edge on a phone.

         The strip lets the next picture run off the right of the screen, and
         the bar goes with it: a bar that stopped short of an edge the photo
         above it crosses reads as a mistake, which is the notch. But the left
         has nothing to bleed into - the picture starts on the page's gutter,
         level with the product title, and so does the bar.

         Above the breakpoint the gallery sits beside the buy column and a bar
         wider than the photo would run into it, so there both edges follow the
         picture.

         Neither side depends on the mode. Alignment was never part of the
         'bleed' treatment; it only got written inside it. */
      var wide = (window.innerWidth || 0) > 749;
      var rest = wide ? null : restLeft();
      var leftX = rest !== null ? rest : (wide ? (shot || frame) : (frame || shot)).left;
      var rightX = (wide ? (shot || frame) : (frame || shot)).right;
      var dl = leftX - b.left;
      var dr = b.right - rightX;
      if (Math.abs(dl) > 0.5) bar.style.marginLeft = dl + 'px';
      if (Math.abs(dr) > 0.5) bar.style.marginRight = dr + 'px';
    }
    seat();
    window.addEventListener('load', seat);
    window.addEventListener('resize', seat);
    try { new ResizeObserver(seat).observe(gallery); } catch (err) {}
    return true;
  }

  if (!build()) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
    window.addEventListener('load', build);
    var tries = 0;
    var iv = setInterval(function () { if (build() || ++tries > 60) clearInterval(iv); }, 50);
  }
}());
}
v2run();
if (window.Shopify && window.Shopify.designMode) {
document.addEventListener('shopify:section:load', function () { try { v2run(); } catch (e) {} });
}
})();
